;(function () {
  // Primary list of options, create new configs below, which just reference these objects
  var optionsLookup = {
    lastHour: {
      key: 'lastHour',
      label: 'Last hour',
      getter: 'getLastHour',
      tooltip: 'detail_lastHour_tooltip',
      translationId: 'detail_lastHour'
    },
    lastDay: {
      key: 'lastDay',
      label: 'Last day',
      startDate: '',
      endDate: '',
      getter: 'getLastDay',
      tooltip: 'detail_lastDay_tooltip',
      translationId: 'detail_lastDay'
    },
    lastWeek: {
      key: 'lastWeek',
      label: 'Last 7 days',
      getter: 'getLastWeek',
      tooltip: '',
      translationId: 'detail_lastSevenDays'
    },
    lastMonth: {
      key: 'lastMonth',
      label: 'Last 30 days',
      getter: 'getLastThirtyDays',
      tooltip: '',
      translationId: 'detail_lastThirtyDays'
    },
    last3Month: {
      key: 'last3Month',
      label: 'Last 3 months',
      getter: 'getLastThreeMonths',
      tooltip: '',
      translationId: 'detail_lastThreeMonths'
    },
    lastYear: {
      key: 'lastYear',
      label: 'Last 12 months',
      getter: 'getLastYear',
      tooltip: 'detail_lastTwelveMonths_tooltip',
      translationId: 'detail_lastTwelveMonths'
    },
    custom: {
      key: 'custom',
      label: 'Custom...',
      translationId: 'detail_customOption'
    },
    live: {
      key: 'live',
      label: 'Live',
      getter: 'getLastHour',
      translationId: 'detail_realTimeLive'
    }
  }

  // Just add a new config if a new set of options needs to be created
  var configs = {
    default: ['lastHour', 'lastDay', 'lastWeek', 'lastMonth', 'custom'],
    live: ['live', 'lastHour', 'lastDay', 'lastWeek', 'lastMonth', 'custom'],
    vulnerabilities: [
      'lastHour',
      'lastDay',
      'lastWeek',
      'lastMonth',
      'lastYear',
      'custom'
    ],
    coverage: ['lastHour', 'lastDay', 'lastWeek', 'lastMonth', 'last3Month'],
    audit: ['lastDay', 'lastWeek', 'lastMonth', 'custom']
  }

  angular.module('contrast.date').constant('DATE_OPTIONS', build())

  // Builds the constant object that this component represents
  function build() {
    var final = {}
    Object.keys(configs).forEach(function (key) {
      final[key.toLowerCase()] = configs[key].map(function (optionKey) {
        return optionsLookup[optionKey]
      })
    })
    return final
  }
})()
